import { Suspense, lazy } from "react";
import { Provider } from "react-redux";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/common/layout";
import Loader from "./components/common/loader";
import { ROUTES } from "./components/core/navigation.js";
import store from "./components/core/store.js";
import { ProtectedFragment } from "./components/protectedFragment/protectedFragment.component.jsx";
import { MODULES } from "./components/permissions/types/permission-types.js";
import useAuthBridge from "./hooks/useAuthBridge.js";
import AppLoader from "./components/appLoader/appLoader.component.jsx";

const Dashboard = lazy(() => import("./components/dashboard/dashboard.jsx"));
const Appointments = lazy(
  () => import("./components/appointments/appointments.container.jsx"),
);
const AppointmentDetails = lazy(
  () =>
    import("./components/appointmentDetails/appointmentDetails.container.jsx"),
);

const Patients = lazy(
  () => import("./components/patients/patients.container.jsx"),
);
const Billings = lazy(
  () => import("./components/billings/billings.container.jsx"),
);
const Guardians = lazy(
  () => import("./components/guardians/guardians.container.jsx"),
);
const Settings = lazy(
  () => import("./components/settings/settings.container.jsx"),
);
const Inventory = lazy(
  () => import("./components/inventory/inventory.container.jsx"),
);
const Suppliers = lazy(
  () => import("./components/suppliers/suppliers.container.jsx"),
);
const Schedule = lazy(
  () => import("./components/schedule/schedule.container.jsx"),
);
const Logs = lazy(() => import("./components/logs/logs.container.jsx"));
const SMSMessages = lazy(
  () => import("./components/smsMessages/smsMessages.container.jsx"),
);
const UnAuthorizedAccess = lazy(
  () => import("./components/unauthorizedAccess"),
);

const App = () => {
  useAuthBridge();

  return (
    <Provider store={store}>
      <Layout>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route
              path={ROUTES.dashboard}
              element={
                <ProtectedFragment module={MODULES.DASHBOARD}>
                  <Dashboard />
                </ProtectedFragment>
              }
            />
            <Route
              path={ROUTES.appointments}
              element={
                <ProtectedFragment module={MODULES.APPOINTMENT}>
                  <Appointments />
                </ProtectedFragment>
              }
            />
            <Route
              path={ROUTES.appointmentDetails}
              element={
                <ProtectedFragment module={MODULES.APPOINTMENT}>
                  <AppointmentDetails />
                </ProtectedFragment>
              }
            />
            <Route
              path={ROUTES.patients}
              element={
                <ProtectedFragment module={MODULES.PATIENT}>
                  <Patients />
                </ProtectedFragment>
              }
            />
            <Route
              path={ROUTES.billings}
              element={
                <ProtectedFragment module={MODULES.BILLING}>
                  <Billings />
                </ProtectedFragment>
              }
            />
            <Route
              path={ROUTES.guardians}
              element={
                <ProtectedFragment module={MODULES.GUARDIAN}>
                  <Guardians />
                </ProtectedFragment>
              }
            />
            <Route
              path={ROUTES.settings}
              element={
                <ProtectedFragment module={MODULES.SETTINGS}>
                  <Settings />
                </ProtectedFragment>
              }
            />
            <Route
              path={ROUTES.inventory}
              element={
                <ProtectedFragment module={MODULES.INVENTORY}>
                  <Inventory />
                </ProtectedFragment>
              }
            />
            <Route
              path={ROUTES.suppliers}
              element={
                <ProtectedFragment module={MODULES.SUPPLIER}>
                  <Suppliers />
                </ProtectedFragment>
              }
            />
            <Route
              path={ROUTES.schedule}
              element={
                <ProtectedFragment module={MODULES.APPOINTMENT}>
                  <Schedule />
                </ProtectedFragment>
              }
            />
            <Route
              path={ROUTES.smsMessages}
              element={
                <ProtectedFragment module={MODULES.APPOINTMENT}>
                  <SMSMessages />
                </ProtectedFragment>
              }
            />
            <Route
              path={ROUTES.logs}
              element={
                <ProtectedFragment module={MODULES.APPOINTMENT}>
                  <Logs />
                </ProtectedFragment>
              }
            />
            <Route path={ROUTES.initializing} element={<AppLoader />} />
            <Route path="*" element={<AppLoader />} />
            <Route
              path={ROUTES.unauthorizedAccess}
              element={<UnAuthorizedAccess lg />}
            />
          </Routes>
        </Suspense>
      </Layout>
    </Provider>
  );
};
export default App;
